import Voting from './base';
import config from 'config';

export default class BestPlayerVoting extends Voting {
  players: string[];

  static path = `${config.backOfficeBasePath}/votings/best_player`;

  static validateConstraints = Object.assign({}, Voting.validateConstraints, {
    players: {
      presence: {message: '^Please select some players'},
      arrayLength: {
        name: 'Players',
        minimum: 2,
        message: '^Please select at least 2 players'
      }
    }
  });

  _getModel() {
    return BestPlayerVoting;
  }

  get _createUrl() {
    return `${config.backOfficeBasePath}/events/:eventId/votings/best_player`
      .replace(':eventId', this.eventId);
  }

  prepareForSave() {
    let { players } = this;
    let data = Object.assign(super.prepareForSave(), {
      players
    });

    return data;
  }

  _parseData(data) {
    return Object.assign(super._parseData(data), {
      players: (data.players || []).map(
        item => typeof item == 'object' && item.id !== undefined ? item.id : item
      )
    });
  }

}



// WEBPACK FOOTER //
// ./src/api/voting/bestPlayer.ts